import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ReadOnlyService } from '../services/read-only.service';

/**
 * Tells the user, once and unmistakably, why nothing on the page can be saved.
 *
 * Without this a read-only user just meets greyed-out buttons and assumes the app is broken. Shown
 * in the app shell whenever the module currently open is one the user only has Viewer access to.
 */
@Component({
    selector: 'app-read-only-banner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatIconModule],
    template: `
    <div class="ro-banner" *ngIf="readOnly.readOnly$ | async" role="status">
      <mat-icon aria-hidden="true">visibility</mat-icon>
      <span>
        <strong>Read-only access.</strong>
        You can view everything in this module, but you cannot save, update or delete anything.
      </span>
    </div>
  `,
    styles: [`
    .ro-banner {
      display: flex; align-items: center; gap: var(--bc-space-2);
      padding: var(--bc-space-2) var(--bc-space-4);
      font: var(--bc-text-meta); color: var(--bc-info);
      background: var(--bc-info-soft);
      border-bottom: 1px solid var(--bc-border);
    }
    .ro-banner strong { font-weight: 700; }
    mat-icon { flex: none; width: 20px; height: 20px; font-size: 20px; }
  `]
})
export class ReadOnlyBannerComponent {
  readonly readOnly = inject(ReadOnlyService);
}
